<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ "Edit Referral Code" }}</div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="labelname"
                v-model="name"
                v-validate="'required'"
                name="labelname"
                placeholder="."
                type="text"
              />
              <label>{{ "Name" }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('labelname')">{{
              errors.first("labelname")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="labelshortname"
                v-model="code"
                v-validate=""
                name="labelshortname"
                placeholder="."
                type="text"
              />
              <label>{{ "Code" }}</label>
            </div>
          </div>
          <p class="error_message"></p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              v-model="is_active"
              name="check-button"
              switch
              unchecked-value="N"
              value="Y"
              class="j-checkbox"
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-12"></div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="OnFinalSubmit(true)"
          >
            {{ $t("update") }}
          </button>
          <b-button class="btn-outline-grey" to="movie-labels" variant="default"
            >{{ $t("cancel") }}
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    TranslationsContainer,
  },
  data() {
    return {
      selectedType: "",
      btenable: false,
      name: "",
      r_id: null,
      is_active: "Y",
      code: "",
      submitted: false,
      CodeDate: [],
    };
  },
  computed: {
    ...mapGetters(["getGlobalOptions"]),
  },
  beforeMount() {
    const { id } = this.$route.query;

    if (id) {
      this.r_id = id;
      this.getSingleCode(id);
    } else {
      this.code = this.randomAlphaNumeric();
    }
  },
  mounted() {},
  methods: {
    randomAlphaNumeric: function () {
      return Math.random().toString(36).replace("0.", "").toUpperCase();
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let service = MasterService.EditReferralCode;

          let payload = {
            name: this.name,
            code: this.code,
            is_active: this.is_active,
          };

          if (this.r_id) {
            payload.r_id = this.r_id;
          } else {
            service = MasterService.AddCode;
          }

          service(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.resetForm();
                this.$toasted.show(data.message);
                if (redirect) {
                  this.$router.push({
                    path: "/master/referral-code",
                  });
                }
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((e) => {
              console.log({
                e,
              });
              this._CatchError(e);
            });
        }
      });
    },

    getSingleCode(labelId) {
      if (labelId) {
        let payload = {
          r_id: labelId,
        };
        MasterService.getReferralCode(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.name = data.Records[0].name;
                this.code = data.Records[0].code;
                this.r_id = data.Records[0].r_id;
                this.ml_type = data.Records[0].ml_type;
                this.is_active = data.Records[0].is_active;
                this.CodeDate = data.Records;
              } else {
                console.log("Error:", data.message);
                this.$toasted.show(data.message);
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    resetForm: function () {
      this.name = "";
      this.is_active = "Y";
      this.code = "";
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ReferralCodeComponents/editCode.vue